import HomeView from './components/Home.vue'

// Import Views - Information
import ApplyProfessionalView from './components/information/ApplyProfessional'
import PrivacyView from './components/information/Privacy'
import PrivacyEnView from './components/information/PrivacyEn'
import PrivacyThView from './components/information/PrivacyTh'
import ServiceView from './components/information/Service'
import TermView from './components/information/Term'
import Covid19TermsView from './components/information/Covid19Terms'
import AboutCleanersView from './components/information/AboutCleaners'
import PricingView from './components/information/Pricing'
import Pdpa from './components/information/Pdpa'
import ServiceProviderPrivacy from './components/information/ServiceProviderPrivacy.vue'

// import BusinessView from './components/information/Business'
import BusinessAisView from './components/information/BusinessAis'
import DecliningBookingView from './components/information/DecliningBooking'
import SafetyView from './components/information/Safety'
// import BigCleaningView from './components/information/BigCleaning'
import BigCleaningNewView from './components/information/BigCleaningNew'
import ThankUsingServiceBigCleaning from './components/information/ThankUsingServiceBigCleaning'
// import PromotionView from './components/information/promotion/Promotion'
// import PromotionReviewView from './components/information/promotion/PromotionReview'
// import HomePackageView from './components/information/homePackage/index'
import NcsView from './components/information/Ncs'
import AcCleaning from './components/information/AcCleaning'
import AcCleaningV2 from './components/information/AcCleaningV2.vue'
import SubscriptionDetail from './components/information/SubscriptionDetail'
import GeneralInformation from './components/information/GeneralInformation'
import ExcellentProvider from './components/information/ExcellentProvider'
import BeneatForBussiness from './components/information/BeneatForBussiness'
import TwitterView from './components/information/Twitter'
import LineLoginView from './components/information/LineLogin'
import LineProviderLoginView from './components/information/LineProviderLogin'
import LineProfessionalLoginView from './components/information/LineProfessionalLogin'
import LineLoginCampaignView from './components/information/LineLoginCampaign'
import LineLoginCallbackView from './components/information/LineLoginCallback'
import LineProviderLoginCallbackView from './components/information/LineProviderLoginCallback'
import LineProfessionalLoginCallbackView from './components/information/LineProfessionalLoginCallback'
// import BeneatForHost from './components/information/BeneatForHost'
import InviteFriendCampaign from './components/information/InviteFriendCampaign'
import Finnix from './components/information/Finnix'

// Import Views - Relax
import RelaxView from './components/relax/Index'
import RelaxHomeView from './components/relax/Home'

// Import Views - Order
import OrderView from './components/order/Index'
import OrderDetailView from './components/order/OrderDetail'
import ConfirmDeclinedOrderView from './components/order/ConfirmDeclinedOrder'
import ConfirmOrderReviseDateTimeView from './components/order/ConfirmOrderReviseDateTime'
import ConfirmBankTransferView from './components/order/ConfirmBankTransfer'
import ConfirmPromptpayView from './components/order/ConfirmPromptpay'
import BookAdditionalHours from './components/order/BookAdditionalHours'
import PurchaseService from './components/order/PurchaseService'
import GiveProfessionalTip from './components/order/GiveProfessionalTip'
import ConfirmProfessionalBooking from './components/order/ConfirmProfessionalBooking'

// Import Views - Booking
import MainBookingView from './components/booking/Index'
import NewBookingView from './components/booking/newSteps/Index'
import BookingView from './components/booking/steps/Booking'
import ChooseCleanerView from './components/booking/steps/ChooseCleaner'
import CheckoutView from './components/booking/steps/Checkout'
import BookingDetailView from './components/booking/components/BookingDetail'
import ThankYouPage from './components/booking/ThankYouPage.vue'

// Import Views - Inbox
import InboxView from './components/inbox/Index'
import MessageView from './components/message/Index'

// Import Views - User
import UserView from './components/user/Index'
import UserEditView from './components/user/EditProfile'
import UserCreditsView from './components/user/Credit'
// import UserPromotionView from './components/user/Promotion'
import UserListingsView from './components/user/listing/Index'
import UserPaymentView from './components/user/payment/Index'
import UserInviteView from './components/user/Invite'
import UserCompanyAddressView from './components/user/companyAddress/Index'
import UserNotificationView from './components/user/Notification'
import ManageUserListingView from './components/user/listing/ManageUserListing'
import CalendarView from './components/user/Calendar'
import PersonalDataManagement from './components/user/PersonalDataManagement'
import UserVoucher from './components/user/Voucher'
import DeleteAccount from './components/user/DeleteAccount'
import ShippingAddress from './components/user/ShippingAddress'
// Import Views - Referral
import ReferralView from './components/referral/Index'

// Import Views - Professional
import CleanerView from './components/professional/Index'
import CleanerDetailView from './components/professional/CleanerDetail'
import CleanerCardView from './components/professional/CleanerCard'
import ProfessionalCardView from './components/professional/ProfessionalCard'
import ProfessionalIncomeView from './components/professional/ProfessionalIncome'
import ProfessionalBonusView from './components/professional/ProfessionalBonus'
import ProfessionalBonusViewV2 from './components/professional/ProfessionalBonusV2'
import ProfessionalDebtView from './components/professional/ProfessionalDebt'
import ProfessionalRegisterView from './components/professional/ProfessionalRegister.vue'
import ProfessionalRegisterShortView from './components/professional/ProfessionalRegisterShortForm'
import ProfessionalRecentReviewsView from './components/professional/ProfessionalRecentReviews'
import ProfessionalPostAddress from './components/professional/ProfessionalPostAddress'
import Agreement from './components/professional/Agreement'
import Login from './components/professional/Login'
import ProfessionalWithHoldingTax from './components/professional/ProfessionalWithHoldingTax'
import ProfessionalView from './components/professional/ProfessionalView'
import ProfessionalDocument from './components/professional/contract/ProfessionalDocument.vue'
import ProfessionalContractIDCard from './components/professional/contract/ProfessionalContractIDCard'
import CriminalHistoryCheck from './components/professional/CriminalHistoryCheck'
import IroningTableConsent from './components/professional/IroningTableConsent'

// Import Views - Experience
import ExperienceView from './components/experience/Index'
import ExperienceDetailView from './components/experience/ExperienceDetail'

// Import Views - Recommend
import RecommendView from './components/recommend/Index'

// Import Views - Review
import ReviewView from './components/review/Review'
import ReviewsView from './components/review/Reviews'
import ReviewReportProblem from './components/review/ReviewReportProblem'

// Import Views - Others
import DownloadApp from './components/others/DownloadApp'
import SCBView from './components/others/SCB'

// Import Views - Sales
import SalesBusinessView from './components/information/sales/SalesBusiness'
import ThankView from './components/information/Thank'

// Import Views - PreBookings
import PreBookingDetailView from './components/preBooking/PreBookingDetail'

// Register / Login - Register
import UserRegisterView from './components/register/Index'
import store from './store/store'

// Notification
import Notifications from './components/notifications/Index'

// ServiceRequest
import ServiceRequestsView from './components/serviceRequest/Index'
import ServiceRequestDetailForPartner from './components/serviceRequest/ServiceRequestDetailForPartner'
import ServiceRequestPayment from './components/serviceRequest/ServiceRequestPayment'
import DisinfectantCleaning from './components/serviceRequest/DisinfectantCleaning'
import ServiceTeamCalendar from './components/serviceRequest/ServiceTeamCalendar'
import ServiceRequestDetail from './components/serviceRequest/ServiceRequestDetail'
import ServiceRequestsBooking from './components/serviceRequest/Booking'

// Payments
import PaymentValidationView from './components/payment/PaymentValidation'
import PaymentServiceRequestValidationView from './components/payment/PaymentServiceRequestValidation'

// Promotions
import PromotionsView from './components/promotion/Index'
import PromotionDetail from './components/promotion/PromotionDetail'

// Import Views - Social
import FacebookPostView from './components/social/FacebookPost'

// Chat Booking
import ChatBookingView from './components/chatBooking/Index'

// Article
import ArticleCategoryView from './components/article/Category'
import ArticleView from './components/article/Article'

// Test Omise
import TestOmiseView from './components/payment/TestOmise'
import QrCodePayment from './components/user/payment/QrCodePayment'
import PreQrPayment from './components/qrPayment/PreQrPayment'

// Examination
// import Examination from './components/professional/Examination'
import ExaminationProfile from './components/professional/ExaminationProfile'
import ProfessionalQuestionnaireTest from './components/professional/ProfessionalQuestionnaireTest'
import AdminTestList from './components/temp/AdminTestList'
import AdminTest from './components/temp/AdminTest'

// Rewards
import RewardsView from './components/reward/Index'
import RewardDetail from './components/reward/RewardDetail'
import UserPoints from './components/reward/UserPoints'
// import UserRewards from './components/reward/UserRewards'
import UserRewardTab from './components/reward/UserRewardTab'
import UserRewardDetail from './components/reward/UserRewardDetail'
import UserRewardDeliveryInfo from './components/reward/UserRewardDeliveryInfo'

// Job Post
import JobPostIndex from './components/jobPost/Index'
import JobPost from './components/jobPost/JobPost'
import JobPostDetail from './components/jobPost/JobPostDetail'
import JobUser from './components/jobPost/JobUser'
import Profile from './components/jobPost/Profile'
// Service
import ServiceDetail from './components/service/ServiceDetail'
// Recruting
import RecrutingDetail from './components/recruting/RecrutingDetail'

// Partner
import PartnerBookingReport from './components/partner/BookingReport'
import BookingPartnerOrderReport from './components/partner/BookingPartnerOrderReport'
import PartnerMainPage from './components/partner/Index'
import BookingGrabReport from './components/partner/BookingGrabReport'
import PartnerLogin from './components/partner/Login'
import TermAndCondition from './components/information/TermAndConditions'

// Q Chang
import QChangView from './components/qChang/Index'
import QChangStep1 from './components/qChang/Step1'
import QChangStep2 from './components/qChang/Step2'

import Maintenance from './components/maintenance/Index'
// form register from agency redirect
import AgencyProfessionalRegister from './components/agencyProfessionalRegister/index'

// campaign
import snapAndShare from './components/campaign/snapAndShare/index'
import cleanStoryChallenge from './components/campaign/cleanStoryChallenge/index'
import LuckyRoulette from './components/campaign/luckyRoulette/Index'
import MillionBookingCelebrate from './components/campaign/millionBookingCelebrate/Index'

import SurveyIroning from './components/survey/IroningForm'
import SurveyBathroomCleaning from './components/survey/BathroomCleaningForm'
import UserFocusGroup from './components/survey/UserFocusGroup'
import IronningTable from './components/survey/IronningTable'
import QChangSurvey from './components/survey/QChangSurvey'
import IRobotSurvey from './components/survey/IRobotSurvey'
import Recruitment from './components/recruitment/Index'

// Feedback
import OperationFeedback from './components/feedback/OperationFeedback'
import ProfessionalFeedback from './components/feedback/ProfessionalFeedback'
import ProfessionalRegisterFeedback from './components/feedback/ProfessionalRegisterFeedback'

// blogs
import Blogs from './components/blogs/Index.vue'
import BlogsDetail from './components/blogs/Content.vue'
// import TestCur from './components/blogs/test'

// Line Liff
import LinemanPromotion from './components/landingPage/LinemanPromotion'
import MillionBookingCelebrateInfo from './components/landingPage/MillionBookingCelebrateInfo'
import LineLiffIndex from './components/lineLiff/Index'
import LineLiffHome from './components/lineLiff/Home'
import LineLiffBooking from './components/lineLiff/Booking'

// Airbnb
import AirbnbLoginCallback from './components/airbnb/AirbnbLoginCallback'

export const routes = [
  { path: '/', component: HomeView },
  { path: '/pdpa', component: Pdpa },
  { path: '/test-qr-code', component: QrCodePayment },
  { path: '/test-omise', component: TestOmiseView },
  { path: '/pre-qr-payments', component: PreQrPayment },
  { path: '/invite-friends', component: InviteFriendCampaign },
  { path: '/finnix', component: Finnix },
  { path: '/apply', component: ApplyProfessionalView },
  { path: '/service', component: ServiceView },
  { path: '/term', component: TermView },
  { path: '/term-and-conditions', component: TermAndCondition },
  { path: '/covid19-terms', component: Covid19TermsView },
  { path: '/privacy', component: PrivacyView },
  { path: '/privacy-en', component: PrivacyEnView },
  { path: '/privacy-th', component: PrivacyThView },
  { path: '/about-the-cleaners', component: AboutCleanersView },
  { path: '/pricing', component: PricingView },
  { path: '/business', component: BeneatForBussiness },
  { path: '/ais-corporate', component: BusinessAisView },
  // { path: '/promotion', component: PromotionView },
  // { path: '/promotion-review', component: PromotionReviewView },
  { path: '/safety', component: SafetyView },
  { path: '/service-requests/booking', component: ServiceRequestsBooking },
  { path: '/service-provider-privacy', component: ServiceProviderPrivacy },
  { path: '/big-cleaning', component: BigCleaningNewView },
  { path: '/big-cleaning/thank', component: ThankUsingServiceBigCleaning },
  // { path: '/big-cleaning-old', component: BigCleaningView },
  { path: '/declining-booking', component: DecliningBookingView },
  { path: '/disinfectant-cleaning', component: DisinfectantCleaning },
  { path: '/download', component: DownloadApp, meta: { requiresAuth: false } },
  { path: '/promotion/scb', component: SCBView, meta: { requiresAuth: false } },
  { path: '/ref', component: ReferralView, meta: { requiresAuth: false } },
  { path: '/review', component: ReviewView, meta: { requiresAuth: false } },
  { path: '/reviews', component: ReviewsView, meta: { requiresAuth: false } },
  { path: '/thank', component: ThankView, meta: { requiresAuth: false } },
  // { path: '/home-package', component: HomePackageView, meta: { requiresAuth: false } },
  { path: '/ncs', component: NcsView, meta: { requiresAuth: false } },
  { path: '/ac-cleaning-old', component: AcCleaning, meta: { requiresAuth: false } },
  // air cleaning v2
  { path: '/ac-cleaning', name: 'AC Cleaning', component: AcCleaningV2, meta: { requiresAuth: false } },
  { path: '/subscription-detail', component: SubscriptionDetail, meta: { requiresAuth: false } },
  { path: '/general-information', component: GeneralInformation, meta: { requiresAuth: false } },
  { path: '/excellent-provider', component: ExcellentProvider, meta: { requiresAuth: false } },
  { path: '/notifications', component: Notifications, meta: { requiresAuth: true } },
  { path: '/service-requests', component: ServiceRequestsView, meta: { requiresAuth: true } },
  { path: '/twitter-campaign', component: TwitterView, meta: { requiresAuth: false } },
  // { path: '/beneat-for-host', component: BeneatForHost, meta: { requiresAuth: false } },
  { path: '/line/login', component: LineLoginView, meta: { requiresAuth: false } },
  { path: '/line-provider/login', component: LineProviderLoginView, meta: { requiresAuth: false } },
  { path: '/line-professional/login', component: LineProfessionalLoginView, meta: { requiresAuth: false } },
  { path: '/line/login-campaign', component: LineLoginCampaignView, meta: { requiresAuth: false } },
  { path: '/line/callback', component: LineLoginCallbackView, meta: { requiresAuth: false } },
  { path: '/line-provider/callback', component: LineProviderLoginCallbackView, meta: { requiresAuth: false } },
  { path: '/line-professional/callback', component: LineProfessionalLoginCallbackView, meta: { requiresAuth: false } },
  { path: '/facebook-post', component: FacebookPostView, meta: { requiresAuth: false } },
  { path: '/chat-booking', component: ChatBookingView, meta: { requiresAuth: false } },
  { path: '/team-service-calendar', component: ServiceTeamCalendar, meta: { requiresAuth: false } },
  { path: '/rewards', component: RewardsView, meta: { requiresAuth: true } },
  { path: '/rewards/:id', component: RewardDetail, meta: { requiresAuth: true } },
  { path: '/user-points', component: UserPoints, meta: { requiresAuth: true } },
  { path: '/user-rewards', component: UserRewardTab, meta: { requiresAuth: true } },
  { path: '/user-rewards/:id', component: UserRewardDetail, meta: { requiresAuth: true } },
  { path: '/user-rewards/:id/delivery-info', component: UserRewardDeliveryInfo, meta: { requiresAuth: true } },
  { path: '/review-problem', component: ReviewReportProblem }, // review report problem
  { path: '/promotions', component: PromotionsView, meta: { requiresAuth: false } },
  { path: '/promotions/:id', component: PromotionDetail, meta: { requiresAuth: false } },
  {
    path: '/job-posts',
    component: JobPostIndex,
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        component: JobPost,
        meta: { requiresAuth: false }
      },
      {
        path: 'profile',
        component: JobUser,
        meta: { requiresAuth: false }
      },
      {
        path: 'user/:id',
        component: Profile,
        meta: { requiresAuth: false }
      }
    ]
  },
  {
    path: '/job-posts/:id',
    component: JobPostDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/line-liff',
    component: LineLiffIndex,
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        component: LineLiffHome,
        meta: { requiresAuth: false }
      },
      {
        path: 'bookings',
        component: LineLiffBooking,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/service-requests/:id',
    name: 'Service Request Detail',
    component: ServiceRequestDetail,
    meta: { requiresAuth: true },
    props: { provider: false }
  },
  {
    path: '/service-requests/:id/payment',
    name: 'Service request payment',
    component: ServiceRequestPayment,
    meta: { requiresAuth: true },
    props: { provider: false }
  },
  {
    path: '/service-requests/:id/for-provider',
    name: 'Service Request',
    component: ServiceRequestDetailForPartner,
    meta: { requiresAuth: false },
    props: { provider: true }
  },
  {
    path: '/recruting/:id',
    name: 'Recruting Detail',
    component: RecrutingDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/payments/:id/validate',
    name: 'Payment Validation',
    component: PaymentValidationView,
    meta: { requiresAuth: false }
  },
  {
    path: '/payments-service-request/:id/validate',
    name: 'Payment Service Request Validation',
    component: PaymentServiceRequestValidationView,
    meta: { requiresAuth: false }
  },
  {
    path: '/article/category',
    component: ArticleCategoryView,
    meta: { requiresAuth: false }
  },
  {
    path: '/article/category/:name',
    component: ArticleView,
    meta: { requiresAuth: false }
  },
  {
    path: '/booking',
    component: MainBookingView,
    meta: { requiresAuth: false },
    children: [
      {
        path: 'start',
        component: NewBookingView,
        name: 'New Booking',
        props: true,
        meta: { requiresAuth: false }
      },
      {
        path: 'new',
        component: BookingView,
        meta: { requiresAuth: false }
      },
      {
        path: 'choose-cleaner',
        component: ChooseCleanerView,
        meta: { requiresAuth: false }
      },
      {
        path: 'checkout',
        component: CheckoutView,
        meta: { requiresAuth: false }
      },
      {
        path: 'detail',
        component: BookingDetailView,
        meta: { requiresAuth: false }
      }
    ]
  },
  {
    path: '/thank-you',
    component: ThankYouPage,
    meta: { requiresAuth: false }
  },
  {
    path: '/inbox',
    component: InboxView,
    meta: { requiresAuth: true }
  },
  {
    path: '/message',
    component: MessageView,
    meta: { requiresAuth: true }
  },
  {
    path: '/user',
    component: UserView,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'edit',
        component: UserEditView,
        name: 'Edit Profile',
        meta: { description: 'User edit profile', requiresAuth: true }
      },
      {
        path: 'credits',
        component: UserCreditsView,
        name: 'Credits',
        meta: { description: 'User credits', requiresAuth: true }
      },
      // {
      //   path: 'my-reviews',
      //   component: UserPromotionView,
      //   name: 'My Reviews',
      //   meta: {description: 'My Reviews', requiresAuth: true}
      // },
      {
        path: 'my-vouchers',
        component: UserVoucher,
        name: 'My Vouchers',
        meta: { description: 'My Vouchers', requiresAuth: true }
      },
      {
        path: 'listings',
        component: UserListingsView,
        name: 'Manage address',
        meta: { description: 'Manage Address', requiresAuth: true }
      },
      {
        path: 'listings/add',
        component: ManageUserListingView,
        name: 'Add address',
        meta: { description: 'Add address', requiresAuth: true }
      },
      {
        path: 'listings/:id/edit',
        component: ManageUserListingView,
        name: 'Edit address',
        meta: { description: 'Edit address', requiresAuth: true }
      },
      {
        path: 'payment',
        component: UserPaymentView,
        name: 'Payment Method',
        meta: { description: 'User payment method', requiresAuth: true }
      },
      {
        path: 'invite',
        component: UserInviteView,
        name: 'Invite Friends',
        meta: { description: 'User invite friends', requiresAuth: true }
      },
      {
        path: 'company-address',
        component: UserCompanyAddressView,
        name: 'Manage Company Address',
        meta: { description: 'Manage Company Address', requiresAuth: true }
      },
      {
        path: 'notifications',
        component: UserNotificationView,
        name: 'Notification Settings',
        meta: { description: 'Notification Settings', requiresAuth: true }
      },
      {
        path: 'personal-data-management',
        component: PersonalDataManagement,
        name: 'Personal Data Management',
        meta: { description: 'Personal Data Management', requiresAuth: true }
      }
    ]
  },
  {
    path: '/user/:id/calendar',
    component: CalendarView,
    name: 'My Calendar',
    meta: { description: 'My Calendar', requiresAuth: false }
  },
  {
    path: '/user/shipping-address',
    name: 'User Shipping Address',
    component: ShippingAddress,
    meta: { requiresAuth: false }
  },
  {
    path: '/my-reservations',
    name: 'My Orders',
    component: OrderView,
    meta: { requiresAuth: true }
  },
  {
    path: '/reservation/:id',
    name: 'My Reservation',
    component: OrderDetailView,
    meta: { requiresAuth: false } // false for testing
  },
  {
    path: '/reservation/:id/additional-hours',
    name: 'Book additional hours',
    component: BookAdditionalHours,
    meta: { requiresAuth: true } // false for testing
  },
  {
    path: '/reservation/:id/purchase-service',
    name: 'Purchase service',
    component: PurchaseService,
    meta: { requiresAuth: true } // false for testing
  },
  {
    path: '/reservation/:id/professional-tip',
    name: 'Give professional tip',
    component: GiveProfessionalTip,
    meta: { requiresAuth: true } // false for testing
  },
  {
    path: '/reservation/:id/confirm-professional-booking',
    name: 'Confirm professional booking',
    component: ConfirmProfessionalBooking,
    meta: { requiresAuth: true } // false for testing
  },
  {
    path: '/confirm-declined-booking/',
    component: ConfirmDeclinedOrderView,
    meta: { requiresAuth: false }
  },
  {
    path: '/confirm-revise-datetime/',
    component: ConfirmOrderReviseDateTimeView,
    meta: { requiresAuth: false }
  },
  {
    path: '/orders/:id/confirm-bank-transfer',
    component: ConfirmBankTransferView,
    meta: { requiresAuth: false }
  },
  {
    path: '/orders/:id/confirm-promptpay',
    component: ConfirmPromptpayView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cleaner/:id',
    name: 'Cleaner Detail',
    component: CleanerDetailView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cleaner/:id/contracts/1',
    component: ProfessionalDocument,
    name: 'Cleaner Contract Document',
    meta: { description: 'Cleaner Contract Document', requiresAuth: false }
  },
  {
    path: '/cleaner/:id/contracts/2',
    component: ProfessionalContractIDCard,
    name: 'Cleaner Contract ID Card',
    meta: { description: 'Cleaner Contract ID Card', requiresAuth: false }
  },
  {
    path: '/cleaner/:id/card',
    component: CleanerCardView,
    meta: { requiresAuth: false }
  },
  {
    path: '/cleaners',
    component: CleanerView,
    meta: { requiresAuth: true }
  },
  {
    path: '/cleaner/:id/consents/1',
    name: 'Criminal history check',
    component: CriminalHistoryCheck,
    meta: { requiresAuth: false }
  },
  {
    path: '/cleaner/consents/1',
    name: 'Criminal history check',
    component: CriminalHistoryCheck,
    meta: { requiresAuth: false }
  },
  {
    path: '/cleaner/:id/consents/2',
    name: 'Ironing table check',
    component: IroningTableConsent,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-login',
    component: Login,
    name: 'Professional Login',
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.tokenProfessional) {
        next({ name: 'Professional With Holding Tax' })
      } else {
        next()
      }
    }
  },
  {
    path: '/professional-dashboard',
    component: ProfessionalView,
    name: 'Professional Dashboard',
    meta: { requiresAuthProfessional: true },
    children: [
      {
        path: 'professional-with-holding-tax',
        component: ProfessionalWithHoldingTax,
        name: 'Professional With Holding Tax'
      }
    ]
  },
  {
    path: '/professional/agreements',
    name: 'Professional Agreements',
    component: Agreement,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional/:id/examination',
    component: ExaminationProfile,
    name: 'Professional Examination',
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-questionnaire/:id/test',
    component: ProfessionalQuestionnaireTest,
    name: 'Professional Questionnaire Test',
    meta: { description: 'Professional Questionnaire Test', requiresAuth: false }
  },
  {
    path: '/professional/:id/card',
    component: ProfessionalCardView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional/:id/post-address',
    component: ProfessionalPostAddress,
    meta: { requiresAuth: false }
  },
  {
    path: '/recommend/:id',
    component: RecommendView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-income/:id',
    component: ProfessionalIncomeView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-bonus/:id',
    component: ProfessionalBonusView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-bonus-v2/:id',
    component: ProfessionalBonusViewV2,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-debt/:id',
    component: ProfessionalDebtView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-register',
    component: ProfessionalRegisterView,
    meta: { requiresAuth: false }
  },
  {
    path: '/professional-register/short',
    component: ProfessionalRegisterShortView,
    meta: { requiresAuth: false }
  },
  {
    path: '/recent-reviews',
    component: ProfessionalRecentReviewsView,
    meta: { requiresAuth: false }
  },
  {
    path: '/relax',
    component: RelaxView,
    meta: { requiresAuth: false },
    children: [
      {
        path: '',
        component: RelaxHomeView,
        meta: { requiresAuth: false }
      }
    ]
  },
  {
    path: '/special-services/search',
    component: ExperienceView,
    meta: { requiresAuth: false }
  },
  {
    path: '/special-services/:id',
    component: ExperienceDetailView,
    name: 'Experience Detail',
    meta: { requiresAuth: false }
  },
  {
    path: '/sales/business',
    component: SalesBusinessView,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'register',
    component: UserRegisterView,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      if (store.state.auth.token) {
        next({ path: '/' })
      } else {
        next()
      }
    }
  },
  {
    path: '/agency-professional-register',
    name: 'Agency Professional Register',
    component: AgencyProfessionalRegister,
    meta: { requiresAuth: false }
  },
  {
    path: '/snap-and-share',
    name: 'Snap and Share',
    component: snapAndShare,
    meta: { requiresAuth: false }
  },
  {
    path: '/clean-story-challenge',
    name: 'Clean Story Challenge',
    component: cleanStoryChallenge,
    meta: { requiresAuth: false }
  },
  {
    path: '/million-booking-celebrate',
    name: 'Million Booking Celebrate',
    component: MillionBookingCelebrate,
    meta: { requiresAuth: false }
  },
  {
    path: '/lucky-roulette',
    name: 'Lucky Roulette',
    component: LuckyRoulette,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey-ironing',
    name: 'Survey Ironing',
    component: SurveyIroning,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey-bathroom-cleaning',
    name: 'Survey Bathroom Cleaning',
    component: SurveyBathroomCleaning,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey/1',
    component: UserFocusGroup,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey/2',
    component: IronningTable,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey/3',
    component: QChangSurvey,
    meta: { requiresAuth: false }
  },
  {
    path: '/survey/irobot',
    component: IRobotSurvey,
    meta: { requiresAuth: false }
  },
  {
    path: '/pre-booking/:id',
    component: PreBookingDetailView,
    meta: { requiresAuth: false }
  },
  {
    path: '/services/:id',
    name: 'Service Detail',
    component: ServiceDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/partners',
    component: PartnerMainPage,
    meta: { requiresAuth: false },
    children: [
      {
        path: 'login',
        name: 'Partner Login',
        component: PartnerLogin,
        meta: { requiresAuthPartner: false },
        beforeEnter: (to, from, next) => {
          if (store.state.authPartner.partner) {
            // ถ้าเป็น grab ให้เข้าหน้ารายงานของ grab ได้เลย
            // แต่ถ้าเป็น partner รายอื่นจะเข้าหน้ารายงานปรกติ
            const pathUrl = store.state.authPartner.partner.id === 20 ? '/partners/grab/report' : `/partners/${store.state.authPartner.partner.id}/report`
            next({ path: pathUrl, replace: true })
          } else {
            next()
          }
        }
      },
      {
        path: 'grab/report',
        name: 'Grab Report',
        component: BookingGrabReport,
        meta: { requiresAuthPartner: true }
      },
      {
        path: ':id/report',
        name: 'Partner Report',
        component: PartnerBookingReport,
        meta: { requiresAuthPartner: true }
      },
      {
        path: ':id/orders/:orderId',
        name: 'Partner Order Report',
        component: BookingPartnerOrderReport,
        meta: { requiresAuthPartner: false }
      }
    ]
  },
  {
    path: '/recruitment',
    name: 'Recruitment',
    component: Recruitment,
    meta: { requiresAuth: false }
  },
  {
    path: '/mikuagency',
    name: 'Miku Agency',
    component: Recruitment,
    meta: { requiresAuth: false }
  },
  /* {
     path: '/partners/:id/report',
     name: 'Booking Report',
     component: PartnerBookingReport,
     meta: { requiresAuth: false }
   },
   {
     path: '/partners/:id/orders/:orderId',
     name: 'Booking Partner Order Report',
     component: BookingPartnerOrderReport,
     meta: { requiresAuth: false }
   }, */
  {
    path: '/delete-account',
    component: DeleteAccount,
    name: 'Delete Account',
    meta: { description: 'Delete Account', requiresAuth: true }
  },
  {
    path: '/q-chang',
    component: QChangView,
    meta: { requiresAuth: false },
    children: [
      {
        path: '1',
        component: QChangStep1,
        name: 'Q Change Step 1',
        meta: { description: 'Q Change step 1', requiresAuth: false }
      },
      {
        path: '2',
        component: QChangStep2,
        name: 'Q Change Step 2',
        meta: { description: 'Q Change step 2', requiresAuth: false }
      }
    ]
  },
  {
    path: '/feedback/operation',
    component: OperationFeedback,
    meta: { requiresAuth: false }
  },
  {
    path: '/feedback/operation-professional',
    component: ProfessionalFeedback,
    meta: { requiresAuth: false }
  },
  {
    path: '/feedback/operation-professional-register',
    component: ProfessionalRegisterFeedback,
    meta: { requiresAuth: false }
  },
  {
    path: '/inconvenience-maintenance',
    name: 'Maintenance',
    component: Maintenance,
    meta: { requiresAuth: false }
  },
  {
    path: '/blog',
    name: 'blogs',
    component: Blogs,
    meta: {
      requiresAuth: false,
      description: 'Blog'
    }
  },
  {
    path: '/blog/:id',
    name: 'blog detail',
    component: BlogsDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/blog/content',
    name: 'blog detail',
    component: BlogsDetail,
    meta: { requiresAuth: false }
  },
  {
    path: '/lineman-promotion', // landing page lineman
    name: 'LinemanPromotion',
    component: LinemanPromotion,
    meta: { requiresAuth: false }
  },
  {
    path: '/million-booking-celebrate/info',
    name: 'MillionBookingCelebrateInfo',
    component: MillionBookingCelebrateInfo,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin/:id/tests',
    component: AdminTestList,
    name: 'Admin Tests',
    meta: { requiresAuth: false }
  },
  {
    path: '/admin/:id/test/:testId',
    component: AdminTest,
    name: 'Admin Test',
    meta: { requiresAuth: false }
  },
  {
    path: '/airbnb/login-callback',
    component: AirbnbLoginCallback,
    meta: { requiresAuth: false }
  },
  { path: '*', redirect: '/' }
]



// WEBPACK FOOTER //
// ./src/routes.js